var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0292969,
    y: 17,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-45 0.0292969 17)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1819 12.7574L16.9999 15.9393L13.8179 12.7574C13.6773 12.6167 13.4865 12.5377 13.2876 12.5377C13.0887 12.5377 12.8979 12.6167 12.7573 12.7574C12.6166 12.898 12.5376 13.0888 12.5376 13.2877C12.5376 13.4866 12.6166 13.6774 12.7573 13.818L15.9393 17L12.7573 20.182C12.6166 20.3226 12.5376 20.5134 12.5376 20.7123C12.5376 20.9112 12.6166 21.102 12.7573 21.2426C12.8979 21.3833 13.0887 21.4623 13.2876 21.4623C13.4865 21.4623 13.6773 21.3833 13.8179 21.2426L16.9999 18.0607L20.1819 21.2426C20.3226 21.3833 20.5133 21.4623 20.7122 21.4623C20.9112 21.4623 21.1019 21.3833 21.2426 21.2426C21.3832 21.102 21.4622 20.9112 21.4622 20.7123C21.4622 20.5134 21.3832 20.3226 21.2426 20.182L18.0606 17L21.2426 13.818C21.3832 13.6774 21.4622 13.4866 21.4622 13.2877C21.4622 13.0888 21.3832 12.898 21.2426 12.7574C21.1019 12.6167 20.9112 12.5377 20.7122 12.5377C20.5133 12.5377 20.3226 12.6167 20.1819 12.7574Z",
    fill: "#1B1B1C",
    stroke: "#1B1B1C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCross);
export default __webpack_public_path__ + "static/media/removeCross.c3dd01a2d5c9c3d980b20b82faef9a72.svg";
export { ForwardRef as ReactComponent };